export var DOMContainerType;
(function (DOMContainerType) {
    DOMContainerType[DOMContainerType["MAP_CONTAINER"] = 0] = "MAP_CONTAINER";
    DOMContainerType[DOMContainerType["BODY"] = 1] = "BODY";
    DOMContainerType[DOMContainerType["MAP_TOP_LEFT"] = 2] = "MAP_TOP_LEFT";
    DOMContainerType[DOMContainerType["MAP_TOP_RIGHT"] = 3] = "MAP_TOP_RIGHT";
    DOMContainerType[DOMContainerType["MAP_BOTTOM_LEFT"] = 4] = "MAP_BOTTOM_LEFT";
    DOMContainerType[DOMContainerType["MAP_BOTTOM_RIGHT"] = 5] = "MAP_BOTTOM_RIGHT";
})(DOMContainerType || (DOMContainerType = {}));
export class BaseInterfaceElement {
    constructor(name, options = {}) {
        this.id = null;
        this.domElements = [];
        this.name = name;
        this.options = {
            ...{},
            ...options,
        };
    }
    addDOM(element, container = DOMContainerType.MAP_CONTAINER) {
        element = $(element);
        this.domElements = [...this.domElements, element];
        switch (container) {
            case DOMContainerType.MAP_CONTAINER:
                if (this.customMap) {
                    $(this.customMap.ol.getOverlayContainerStopEvent()).append(element);
                }
                break;
            case DOMContainerType.MAP_TOP_LEFT:
                if (this.customMap) {
                    $(`#${this.customMap.selector}`)
                        .find('[data-app-map="top_left"]')
                        .append(element);
                }
                break;
            case DOMContainerType.MAP_TOP_RIGHT:
                if (this.customMap) {
                    $(`#${this.customMap.selector}`)
                        .find('[data-app-map="top_right"]')
                        .append(element);
                }
                break;
            case DOMContainerType.MAP_BOTTOM_LEFT:
                if (this.customMap) {
                    $(`#${this.customMap.selector}`)
                        .find('[data-app-map="bottom_left"]')
                        .append(element);
                }
                break;
            case DOMContainerType.MAP_BOTTOM_RIGHT:
                if (this.customMap) {
                    $(`#${this.customMap.selector}`)
                        .find('[data-app-map="bottom_right"]')
                        .append(element);
                }
                break;
            case DOMContainerType.BODY:
                $('body').append(element);
                break;
        }
        return element;
    }
    _handle(customMap, id) {
        this.customMap = customMap;
        this.id = id;
        let _ = this;
    }
    _handleRemove() {
        for (const element of this.domElements) {
            element.remove();
        }
    }
}
